import * as httpErrorsTypes from '../../../consts/app/httpErrorsTypes';
import * as loaderNames from '../../../consts/loader/loaderNames';
import * as muleSoftResponseErrorTypes from '../../../consts/muleSoft/muleSoftResponseErrorTypes';
import * as routePaths from '../../../consts/route/routePaths';
import ICC_PRODUCT_STATUS_TYPES from '../../../enums/icc/iccProductStatusTypes';
import {amplitudeRegistrationTracking} from '../../../services/amplitude';
import modalService from '../../../services/modalService';
import muleSoftProductService from '../../../services/muleSoft/muleSoftProductService';
import productService from '../../../services/product/productService';
import appRouterService from '../../../services/route/appRouterService';
import routerService from '../../../services/routerService';
import yapConnectionService from '../../../services/yap/yapConnectionService';
import {setConsumerProductsStatus, updateConsumerProductsStatus} from '../../../state/ducks/consumer';
import {hideLoader, setIsDoubleRegistration, showLoader} from '../../../state/ducks/global';
import {showDeviceHolderRegistrationModalAction, showManualRegistrationModalAction} from '../../../state/ducks/modal';
import {setProductToChangeRegisteringStatus} from '../../../state/ducks/productSettings';
import {
    makeSelectIsMuleSoftConsumerProductRegistered,
    makeSelectLinkedMuleSoftConsumerProductsByCodentify,
} from '../../../state/selectors/consumer';
import {selectIotDeviceData} from '../../../state/selectors/iotDevice';
import {dispatch, getState} from '../../../state/store';

const useManualRegistrationSubmit = ({registrationError, codentify, setRegistrationError, modalType, isHolder}) => {
    const location = routerService.getCurrent();
    const isRegistrationPage = location === routePaths.REGISTRATION;

    const onCloseModal = () => {
        modalService.hideModal(modalType);
    };

    const getIotDeviceRegisterData = (codentify, isPackCodentify) => {
        const iotDevice = selectIotDeviceData(getState());
        const {device, holder} = iotDevice || {};
        const {isP4, status: chargerStatus, isHolderConnected, deviceSerialNumber: chargerSerialNumber} = device || {};
        const {deviceSerialNumber: holderSerialNumber, status: holderStatus} = holder || {};
        const linkedMuleSoftConsumerProductsByCodentify =
            makeSelectLinkedMuleSoftConsumerProductsByCodentify(codentify)(getState()) || [];

        const getIsEnteredCodentifyCorrespondentToConnectedDevice = () => {
            if (isPackCodentify) {
                const isAnyCorrespondent = linkedMuleSoftConsumerProductsByCodentify.some(
                    (mulesoftProduct) =>
                        mulesoftProduct.deviceSerialNumber === chargerSerialNumber ||
                        mulesoftProduct.deviceSerialNumber === holderSerialNumber
                );

                return isAnyCorrespondent;
            } else {
                const muleSoftDeviceSerialNumber = linkedMuleSoftConsumerProductsByCodentify[0]?.deviceSerialNumber;

                return (
                    muleSoftDeviceSerialNumber === chargerSerialNumber ||
                    muleSoftDeviceSerialNumber === holderSerialNumber
                );
            }
        };

        const isEnteredCodentifyCorrespondentToConnectedDevice = getIsEnteredCodentifyCorrespondentToConnectedDevice();
        const isCurrentDeviceRegistered = productService.getIsRegistered(chargerStatus);
        const isCurrentHolderRegistered = isHolderConnected ? productService.getIsRegistered(holderStatus) : true;
        const isFullyRegistered = isCurrentDeviceRegistered && isCurrentHolderRegistered;
        const isNoOneRegistered = !isCurrentDeviceRegistered && !isCurrentHolderRegistered;

        return {
            isEnteredCodentifyCorrespondentToConnectedDevice,
            isFullyRegistered,
            isNoOneRegistered,
            isChargerRegistered: isCurrentDeviceRegistered,
            isHolderRegistered: isCurrentHolderRegistered,
            chargerSerialNumber,
            holderSerialNumber,
            isP4,
        };
    };

    const mapErrorCode = (errorCode) => {
        switch (errorCode) {
            case httpErrorsTypes.NOT_FOUND:
                return muleSoftResponseErrorTypes.NOT_FOUND;
            case httpErrorsTypes.CONFLICT:
                return muleSoftResponseErrorTypes.ALREADY_OWNED;
            default:
                return muleSoftResponseErrorTypes.ERROR;
        }
    };

    const setRegistrationMuleSoftProductStatus = ({deviceSerialNumber, status, statusMessage, isHolder}) => {
        dispatch(setProductToChangeRegisteringStatus({deviceSerialNumber, codentify, isHolder}));

        const data = {
            deviceSerialNumber,
            codentify,
            status,
            statusMessage,
        };

        if (isHolder) {
            dispatch(updateConsumerProductsStatus(data));
        } else {
            dispatch(setConsumerProductsStatus([data]));
        }
    };

    const showRegistrationLoader = (isHide) => {
        if (isRegistrationPage) return;

        const loaderAction = isHide ? hideLoader : showLoader;

        dispatch(loaderAction(loaderNames.MANUAL_REGISTERING_LOADER));
    };

    const registrationAction = async (isPackCodentify) => {
        showRegistrationLoader();
        onCloseModal();

        try {
            const {
                isChargerRegistered: isChargerRegisteredBeforeLink,
                isHolderRegistered: isHolderRegisteredBeforeLink,
            } = getIotDeviceRegisterData(codentify, isPackCodentify);

            amplitudeRegistrationTracking.trackRegistrationStarted(isHolder);
            await muleSoftProductService.linkProduct(codentify, isPackCodentify);

            const {
                isEnteredCodentifyCorrespondentToConnectedDevice,
                isFullyRegistered,
                isNoOneRegistered,
                isChargerRegistered,
                isHolderRegistered,
                chargerSerialNumber,
                holderSerialNumber,
            } = getIotDeviceRegisterData(codentify, isPackCodentify);

            if (isChargerRegisteredBeforeLink !== isChargerRegistered) {
                setRegistrationMuleSoftProductStatus({
                    deviceSerialNumber: chargerSerialNumber,
                    status: ICC_PRODUCT_STATUS_TYPES.REGISTERED,
                });
            }

            if (isHolderRegisteredBeforeLink !== isHolderRegistered) {
                setRegistrationMuleSoftProductStatus({
                    deviceSerialNumber: holderSerialNumber,
                    status: ICC_PRODUCT_STATUS_TYPES.REGISTERED,
                    isHolder: true,
                });
            }

            if (isEnteredCodentifyCorrespondentToConnectedDevice) {
                if (isFullyRegistered) {
                    if (isRegistrationPage) {
                        appRouterService.forwardToDeviceRegistrationPage();
                    }
                } else {
                    if (isNoOneRegistered) {
                        dispatch(
                            showManualRegistrationModalAction({
                                isManualRegistrationFailed: true,
                                manualRegistrationError: true,
                                isHolder,
                            })
                        );
                    } else {
                        if (isChargerRegistered) {
                            if (isRegistrationPage) {
                                appRouterService.forwardToDeviceRegistrationPage();
                            }
                        } else {
                            dispatch(
                                showManualRegistrationModalAction({
                                    isManualRegistrationFailed: true,
                                    manualRegistrationError: true,
                                    isHolder,
                                })
                            );
                        }
                    }
                }
            } else {
                dispatch(
                    showManualRegistrationModalAction({
                        manualRegistrationError: muleSoftResponseErrorTypes.WRONG_DEVICE,
                        codentifyWithError: codentify,
                        isHolder,
                    })
                );
            }
        } catch (e) {
            const errorCode = e?.response?.status;
            const error = mapErrorCode(errorCode || muleSoftResponseErrorTypes.ERROR);

            await updateCodentify();

            dispatch(
                showManualRegistrationModalAction({
                    isManualRegistrationFailed: true,
                    manualRegistrationError: error,
                    codentifyWithError: codentify,
                    isHolder,
                })
            );
            showRegistrationLoader(true);
        }
        showRegistrationLoader(true);
    };

    const updateCodentify = async () => {
        const {chargerSerialNumber, holderSerialNumber, isP4} = getIotDeviceRegisterData();
        const isSkipRegistrationEnabled = productService.isSkipRegistrationEnabled(isP4);

        if (!isSkipRegistrationEnabled) return;

        await yapConnectionService.updateCodentifyAndAssets({
            serial: chargerSerialNumber,
            holderSerial: holderSerialNumber,
            isForceCall: true,
        });
    };

    const onSubmit = async () => {
        dispatch(setIsDoubleRegistration(false));
        const INPUT_REGEX = /(^[A-Z0-9]{14})|(^[A-Z0-9]{12})$/;
        const isValidCodentify = codentify?.match(INPUT_REGEX);

        if (!isValidCodentify) {
            setRegistrationError(muleSoftResponseErrorTypes.INVALID_CODENTIFYID);
            return;
        }

        if (registrationError === muleSoftResponseErrorTypes.INVALID_CODENTIFYID) {
            setRegistrationError(false);
        }
        const PACK_CODENTIFY_LENGTH = 12;
        const isPackCodentify = codentify.length === PACK_CODENTIFY_LENGTH;
        const isMuleSoftConsumerProductRegistered = makeSelectIsMuleSoftConsumerProductRegistered(codentify)(
            getState()
        );
        const {isEnteredCodentifyCorrespondentToConnectedDevice, isHolderRegistered} = getIotDeviceRegisterData(
            codentify,
            isPackCodentify
        );

        if (isMuleSoftConsumerProductRegistered) {
            if (isEnteredCodentifyCorrespondentToConnectedDevice) {
                if (isPackCodentify) {
                    await registrationAction(isPackCodentify);
                } else {
                    onCloseModal();

                    if (isRegistrationPage) {
                        appRouterService.forwardToDeviceRegistrationPage();
                    }

                    if (isHolderRegistered) return;

                    // Show Holder Registration popup if holder is not registered
                    dispatch(showDeviceHolderRegistrationModalAction());
                }
            } else {
                setRegistrationError(muleSoftResponseErrorTypes.WRONG_DEVICE);
            }
            return;
        }

        await registrationAction(isPackCodentify);
    };

    return {
        onSubmit,
    };
};

export default useManualRegistrationSubmit;
